export const frontmatter = {
    "draft": true,
    "title": "Create your first chatbot in 5 minutes",
    "description": "Learn how to configure your first AI assistant in OnnIA, train it with documents, and test it immediately.",
    "sidebar_label": "First Chatbot",
    "sidebar_group": "quickstart",
    "sidebar_order": 3
}

export const toc = [
    {
        "depth": 2,
        "id": "what-are-we-going-to-build",
        "value": "What are we going to build?"
    },
    {
        "depth": 2,
        "id": "step-by-step-your-active-chatbot",
        "value": "Step by step: Your active chatbot"
    },
    {
        "depth": 2,
        "id": "pro-tips-to-improve-your-chatbot",
        "value": "Pro tips to improve your chatbot"
    },
    {
        "depth": 2,
        "id": "quick-troubleshooting",
        "value": "Quick troubleshooting"
    },
    {
        "depth": 3,
        "id": "how-do-i-connect-this-chatbot-to-my-whatsapp-number",
        "value": "How do I connect this chatbot to my WhatsApp number?"
    },
    {
        "depth": 3,
        "id": "what-happens-if-the-ai-doesnt-know-how-to-answer",
        "value": "What happens if the AI doesn't know how to answer?"
    }
]